import React from "react";
import Login from "../auth/Login";

function Admin() {
  return <Login />;
}

export default Admin;
